import { render, staticRenderFns } from "./ReportParagraphs.vue?vue&type=template&id=0f65a251"
import script from "./ReportParagraphs.vue?vue&type=script&lang=js"
export * from "./ReportParagraphs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports